module.exports = __webpack_public_path__ + "img/img_side_plane.cd751e5d.png";